
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 27.829 27.829"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Сгруппировать 22562"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22561","fill":"none","stroke":"#f70","stroke-width":"1.5"}},[_c('g',{attrs:{"data-name":"Прямоугольник 1854","transform":"rotate(-19 21.298 3.564)"}},[_c('rect',{attrs:{"width":"21.894","height":"21.894","rx":"4","stroke":"none"}}),_c('rect',{attrs:{"x":".75","y":".75","width":"20.394","height":"20.394","rx":"3.25"}})]),_c('path',{attrs:{"data-name":"Контур 539","d":"M13.103 14.855s3.107 4.888 2.214 9.019c.911-.28 8.515-2.732 8.934-3.166 2.218-2.3.694-3.487 0-5.47-4.615 1.327-11.148-.383-11.148-.383z"}})])])])
          )
        }
      }
    